<template>
  <van-popup
    v-model="visible"
    :close-on-click-overlay="!loading"
    :style="{ maxHeight: 'calc(100vh - 56px)', paddingBottom: '0' }"
    position="bottom"
    round
    @close="handleClose"
  >
    <div class="vip-redeem-popup">
      <div class="vip-redeem-popup__header">
        <div class="vip-redeem-popup__title">输入兑换码</div>
        <van-icon name="cross" size="22" @click="handleClose"/>
      </div>

      <div class="vip-redeem-popup__merchant">当前商户：{{ merchantLabel }}</div>

      <div class="vip-redeem-popup__form">
        <van-field
          v-model.trim="exchangeCode"
          :disabled="loading"
          clearable
          maxlength="32"
          input-align="center"
          placeholder="请填写兑换码"
        />
      </div>

      <div class="vip-redeem-popup__notice">兑换成功后将自动开通 VIP</div>

      <div class="vip-redeem-popup__footer">
        <van-button
          :loading="loading"
          :disabled="!exchangeCode"
          color="linear-gradient(135deg, #ff7a18, #ffb347)"
          round
          size="large"
          type="primary"
          @click="submitRedeem"
        >
          立即兑换
        </van-button>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'VipRedeemPopup',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    merchantLabel: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      visible: false,
      exchangeCode: ''
    }
  },
  watch: {
    show: {
      immediate: true,
      handler (val) {
        this.visible = val
        if (!val) {
          this.exchangeCode = ''
        }
      }
    },
    visible (val) {
      if (!val) {
        this.$emit('close')
      }
    }
  },
  methods: {
    handleClose () {
      if (this.loading) return
      this.visible = false
    },
    submitRedeem () {
      if (this.loading) return
      const code = (this.exchangeCode || '').trim().toUpperCase()
      if (!code) {
        this.$toast('请输入兑换码')
        return
      }
      this.$emit('submit', code)
    }
  }
}
</script>

<style scoped>
.vip-redeem-popup {
  padding: 20px 16px calc(20px + env(safe-area-inset-bottom) + 64px);
  background: #fffaf5;
}

.vip-redeem-popup__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  color: #7c2d12;
}

.vip-redeem-popup__title {
  font-size: 24px;
  font-weight: 700;
  color: #7c2d12;
}

.vip-redeem-popup__merchant {
  margin-bottom: 14px;
  font-size: 15px;
  color: #9a3412;
}

.vip-redeem-popup__form {
  margin-top: 0;
  padding: 14px;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.06);
}

.vip-redeem-popup__form :deep(.van-field) {
  padding: 14px 12px;
  background: #fff7ed;
  border-radius: 12px;
}

.vip-redeem-popup__form :deep(.van-field__control) {
  font-size: 22px;
  line-height: 1.4;
  color: #7c2d12;
}

.vip-redeem-popup__form :deep(.van-field__control::placeholder) {
  color: #c2410c;
  opacity: 0.7;
}

.vip-redeem-popup__notice {
  margin-top: 12px;
  font-size: 15px;
  line-height: 1.6;
  color: #9a3412;
  text-align: center;
}

.vip-redeem-popup__footer {
  padding: 18px 0 0;
  position: sticky;
  bottom: calc(env(safe-area-inset-bottom) + 12px);
  background: linear-gradient(180deg, rgba(255, 250, 245, 0), #fffaf5 28%, #fffaf5 100%);
}
</style>
